import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChefHatIcon, XIcon } from 'lucide-react';
const notThis = ['It is not a random recipe collection.', 'It is not a traditional baking ebook.', 'It is not material made for home bakers that you have to adapt.'];
const flow = ['OPEN', 'CHOOSE', 'SEE', 'TEACH'];
export function SolutionReveal() {
  return <section className="bg-cream px-4 py-20 sm:py-24" data-id="element-201" data-mp="1mtbftdr8ac1k">
      <div className="mx-auto max-w-4xl text-center" data-id="element-202" data-mp="z25ysv9jxdpo">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-203" data-mp="u2jk0he2rper">
          <span className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full border border-champagne bg-champagne-light text-champagne-deep" data-id="element-204" data-mp="1407r86svapdt">
            <ChefHatIcon size={25} data-id="element-205" data-mp="2jj2gjuq44vft" />
          </span>
          <h2 className="mt-5 font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-206" data-mp="2feuqnu7x59g0">
            The Complete <span className="text-raspberry" data-id="element-207" data-mp="2bvfnl10dijx3">6-in-1</span> Visual
            Pastry Teaching System
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-sm font-bold uppercase tracking-[0.12em] text-espresso" data-id="element-208" data-mp="2gwwi8es9la58">
            6 Complete Volumes ·{' '}
            <span className="text-raspberry" data-id="element-209" data-mp="2pvqaxu2h5gdi">150 Ready-to-Teach</span> Lessons ·
            5 Professional Bonuses ·{' '}
            <span className="text-raspberry" data-id="element-210" data-mp="1t6siwjm3zwk1">100% Visual</span>
          </p>
        </motion.div>

        <div className="mt-10 grid gap-5 text-left md:grid-cols-2" data-id="element-211" data-mp="1x7m3p4498v8p">
          <div className="space-y-4 rounded-2xl border border-blush-line bg-blush p-6" data-id="element-212" data-mp="225e0ocjrb7jr">
            <p className="text-sm font-semibold text-espresso" data-id="element-213" data-mp="26wcixhob2fpn">
              Pastry Instructor Ready…
            </p>
            {notThis.map(item => <div key={item} className="flex gap-3 text-sm leading-6 text-cocoa" data-id="element-214" data-mp="19gyn7ug9wxaj">
                <XIcon size={18} className="mt-0.5 shrink-0 text-raspberry" aria-hidden="true" data-id="element-215" data-mp="2hqz35cy5n3dq" />
                {item}
              </div>)}
          </div>
          <div className="flex rounded-2xl border border-champagne bg-champagne-light p-6" data-id="element-216" data-mp="2qihkhr6u7p8e">
            <div className="flex gap-3 self-center text-lg font-medium leading-8 text-espresso" data-id="element-217" data-mp="2mj0aqlkdo5xf">
              <CheckIcon size={22} className="mt-1.5 shrink-0 text-forest" aria-hidden="true" data-id="element-218" data-mp="1ytedw4rha2sl" />
              It is a complete professional teaching system created specifically
              for pastry instructors.
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-serif text-3xl font-semibold text-espresso sm:text-4xl" data-id="element-219" data-mp="22seurhqeavcy">
          {flow.map((word, index) => <React.Fragment key={word} data-id="element-220" data-mp="3e8lkzpoqb8v6" data-mpi={index}>
              {index > 0 && <span className="text-champagne-deep" aria-hidden="true" data-id="element-221" data-mp="3mpvy8gzqmrnl">
                  →
                </span>}
              <span className={word === 'SEE' ? 'text-raspberry' : ''} data-id="element-222" data-mp="3qtaffazexe2m">
                {word}
              </span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}